import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { CtaButton } from './CtaButton';
import { pricingChecklist } from '../data/content';
export function PricingCard() {
  return <div className="mx-auto w-full max-w-xl overflow-hidden rounded-2xl border-2 border-gold bg-white shadow-2xl shadow-black/30" data-id="element-159" data-mp="1m5cheolbn4cp">
      <div className="bg-navy-800 px-6 py-5 text-center" data-id="element-160" data-mp="1i4ix057387ok">
        <p className="font-display text-base font-extrabold uppercase tracking-wide text-white sm:text-lg" data-id="element-161" data-mp="2et8fnxqjh4bl">
          🏆 Cricket Ready™ — Complete Package
        </p>
        <p className="mt-1 text-xs font-medium uppercase tracking-[0.16em] text-gold" data-id="element-162" data-mp="2535kprzuxgam">
          1 Main Volume + 5 Strategic Bonuses
        </p>
      </div>

      <div className="px-6 py-8 sm:px-10" data-id="element-163" data-mp="21127axtmo1mp">
        <div className="text-center" data-id="element-164" data-mp="2xj7wxyg51f4g">
          <p className="text-sm font-medium text-slate-400 line-through" data-id="element-165" data-mp="2xk9l94m5zy44">$90</p>
          <div className="mt-1 flex items-end justify-center gap-2" data-id="element-166" data-mp="2sshrymbmjeaa">
            <span className="font-display text-6xl font-black leading-none text-navy-800 sm:text-7xl" data-id="element-167" data-mp="32kc7yt0ny298">
              $27
            </span>
            <span className="pb-2 text-sm font-semibold text-slate-500" data-id="element-168" data-mp="37idpvamcrvj4">
              one-time
            </span>
          </div>
          <div className="mt-4 inline-flex flex-wrap items-center justify-center gap-2" data-id="element-169" data-mp="2su97k7r7pm0v">
            <span className="rounded-full bg-grass/10 px-3 py-1 text-xs font-bold uppercase tracking-wide text-grass-dark" data-id="element-170" data-mp="2xs1adwteasju">
              Save $63
            </span>
            <span className="rounded-full bg-gold/15 px-3 py-1 text-xs font-bold uppercase tracking-wide text-gold-dark" data-id="element-171" data-mp="2ot7g4d3jee9g">
              Lifetime Access
            </span>
          </div>
        </div>

        <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-172" data-mp="2etyf50a97zdl">
          {pricingChecklist.map(item => <li key={item} className="flex items-center gap-2 text-sm font-medium text-slate-700" data-id="element-173" data-mp="841zz8322450">
              <CheckIcon className="h-4 w-4 shrink-0 text-grass" aria-hidden="true" data-id="element-174" data-mp="d2lkd42037v9" />
              {item}
            </li>)}
        </ul>

        <div className="mt-8 rounded-xl bg-navy-800 px-4 py-5" data-id="element-175" data-mp="6ltlgwrwwwut">
          <p className="mb-3 text-center text-[11px] font-bold uppercase tracking-[0.18em] text-gold" data-id="element-176" data-mp="1p3508c73z8v">
            Launch price ends in
          </p>
          <Countdown data-id="element-177" data-mp="3tu70u02d1tni" />
        </div>

        <div className="mt-6" data-id="element-178" data-mp="ud8t952gk6dg">
          <CtaButton href="https://cricket-ready.impultienda.ar/checkout" data-id="element-179" data-mp="uc7fgsu255s1" />
        </div>

        <p className="mt-4 text-center text-xs font-medium text-slate-500" data-id="element-180" data-mp="pexh2nooxjs2">
          Backed by our 7-day money-back guarantee
        </p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 border-t border-slate-100 pt-5 text-[11px] font-medium text-slate-500" data-id="element-181" data-mp="kkjikceqewj6">
          <span data-id="element-182" data-mp="1d407ajxe4ky6">🔒 Secure Payment</span>
          <span data-id="element-183" data-mp="1d51mn0lfvtlp">⚡ Instant Access</span>
          <span data-id="element-184" data-mp="18c8cfx77bt28">🛡️ 7-Day Guarantee</span>
          <span data-id="element-185" data-mp="18adsom7o26zq">💳 Card · GooglePay · ApplePay</span>
        </div>
        <p className="mt-3 text-center text-[11px] text-slate-400" data-id="element-186" data-mp="2r09x8mc7hjtt">
          💱 You'll be charged in your local currency
        </p>
      </div>
    </div>;
}